import React from 'react';
import { Link } from 'react-router-dom';

import { RegistrationStatus } from '@sayyesschool/common/entities/registration';
import ConfirmButton from '@sayyesschool/frontend/components/confirm-button';
import CopyButton from '@sayyesschool/frontend/components/copy-button';
import { StatusIcon } from '@sayyesschool/frontend/features/registrations';
import { ButtonGroup, IconButton, List } from '@sayyesschool/frontend/ui-components';

export default function MeetingsList({ learner, meetings, onAdd, onUpdate, onDelete }) {
    return (
        <List>
            {meetings?.map(meeting => {
                const registrations = meeting.registrations;
                const registration = registrations?.find(reg => reg.userId === learner.id);

                return <List.Item
                    key={meeting.id}
                    as={Link}
                    to={meeting.url}
                    content={{
                        primary: meeting.title,
                        secondary: meeting.datetime
                    }}
                    end={<ButtonGroup
                        variant="plain"
                        spacing="4px"
                    >
                        {(meeting.isScheduled || meeting.isStarted) && registration?.joinUrl &&
                            <CopyButton
                                title="Копировать ссылку для входа"
                                icon="link"
                                copyContent={registration?.joinUrl}
                            />
                        }

                        {meeting.isEnded ? <>
                            <IconButton
                                title="Отметить присутствие"
                                icon={StatusIcon[RegistrationStatus.Attended]}
                                color={registration?.isAttended ? 'success' : undefined}
                                variant={registration?.isAttended ? 'soft' : undefined}
                                onClick={() => onUpdate(meeting, registration, { status: RegistrationStatus.Attended })}
                            />

                            <IconButton
                                title="Отметить отсутствие"
                                icon={StatusIcon[RegistrationStatus.Missed]}
                                color={registration?.isMissed ? 'danger' : undefined}
                                variant={registration?.isMissed ? 'soft' : undefined}
                                onClick={() => onUpdate(meeting, registration, { status: RegistrationStatus.Missed })}
                            />
                        </> : <>
                            {registration ? (
                                <>
                                    <IconButton
                                        title="Подтвердить участие"
                                        icon={StatusIcon[RegistrationStatus.Approved]}
                                        color={registration?.isApproved ? 'success' : undefined}
                                        variant={registration?.isApproved ? 'soft' : undefined}
                                        onClick={() => onUpdate(meeting, registration, { status: RegistrationStatus.Approved })}
                                    />

                                    <IconButton
                                        title="Отменить участие"
                                        icon={StatusIcon[RegistrationStatus.Canceled]}
                                        color={registration?.isCanceled ? 'danger' : undefined}
                                        variant={registration?.isCanceled ? 'soft' : undefined}
                                        onClick={() => onUpdate(meeting, registration, { status: RegistrationStatus.Canceled })}
                                    /></>
                            ) : (
                                <IconButton
                                    title="Зарегистрироваться на встречу"
                                    icon={StatusIcon[RegistrationStatus.Attended]}
                                    onClick={() => onAdd(meeting, registration)}
                                />
                            )}
                        </>}

                        {registration && (
                            <ConfirmButton
                                title="Удалить"
                                message="Вы уверены, что хотите удалить регистрацию?"
                                description="Это действие нельзя отменить"
                                icon="delete"
                                color="danger"
                                onConfirm={() => onDelete(meeting, registration)}
                            />
                        )}
                    </ButtonGroup>}
                />;
            }
            )}
        </List>
    );
}